<div class="cpf-section">
  <div class="cpf-divider">
    <span class="divider-line"></span>
    <span class="divider-text">{{ sectionTitle }}</span>
    <span class="divider-line"></span>
  </div>

  <div class="form-group">
    <label class="form-label">
      {{ label }}<span class="required">*</span>
    </label>
    <div class="input-container" [class.error]="isInvalidCpf">
      @if (initialFocus) {
        <input
          type="text"
          [formControl]="control"
          [placeholder]="placeholder"
          (input)="onCpfInput($event)"
          maxlength="14"
          inputmode="numeric"
          autocomplete="off"
          [attr.aria-invalid]="isInvalidCpf"
          cdkFocusInitial />
      } @else {
        <input
          type="text"
          [formControl]="control"
          [placeholder]="placeholder"
          (input)="onCpfInput($event)"
          maxlength="14"
          inputmode="numeric"
          autocomplete="off"
          [attr.aria-invalid]="isInvalidCpf" />
      }
      @if (isInvalidCpf) {
        <div class="input-status error">
          <mzic-svg src="assets/icons/mzic-close-filled.svg" />
        </div>
      }
    </div>
    @if (isInvalidCpf) {
      <p class="error-message">{{ invalidError }}</p>
    }
  </div>

  @if (privacyInfo) {
    <div class="privacy-info">
      <mzic-svg src="assets/icons/mzic-lock.svg" />
      <span>{{ privacyInfo }}</span>
    </div>
  }
</div>
